// OSI-788: признак владельца помещения («Владелец») — общий хелпер для разделов
// «Помещения/Квартиры» и «Сальдо».
//
// ВАЖНО про формат хранения: бэк принимает признак СТРОГО русской строкой —
// OSI.Core/OSI.Core.Types/Models/Requests/AbonentRequest.cs, атрибут
// [Values("Собственник", "Арендатор")] (плюс "" и null). Любое другое значение —
// в т.ч. казахский перевод — приводит к 400 при PUT/POST /api/Abonent.
// Поэтому в БД и в payload всегда лежит русская строка, а перевод существует
// ИСКЛЮЧИТЕЛЬНО на уровне отображения (valueFormatter грида).

// Канонические значения, которые допускает бэк.
export const OWNER_VALUES = {
  OWNER: 'Собственник',
  ARENDATOR: 'Арендатор'
} as const;

// Значение считается пустым, если это null/undefined/пустая строка (в БД встречаются оба
// варианта: NULL и '' — старый фронт отправлял пустую строку). Используется для правила
// «колонка скрыта по умолчанию, если значение пусто У ВСЕХ строк».
export const isOwnerEmpty = (value: unknown): boolean => !String(value ?? '').trim();

// Перевод значения для ОТОБРАЖЕНИЯ. Переиспользуем существующие ключи локализации:
// common:owner (ru «Собственник» / kk «Меншік иесі») и common:arendator (ru «Арендатор» / kk «Жалдаушы»).
// Неизвестные значения возвращаем как есть, чтобы не терять данные на экране.
export const translateOwner = (value: unknown, t: (key: string) => string): string => {
  if (isOwnerEmpty(value)) return '';

  const raw = String(value).trim();

  if (raw === OWNER_VALUES.OWNER) return t('common:owner');
  if (raw === OWNER_VALUES.ARENDATOR) return t('common:arendator');

  return raw;
};
